import Vue from 'vue'
import Vuex from 'vuex'
import { object } from '@/utils/status'
import { getAuthToken, getAuthTokenByFolio } from '@/api/auth'
import { getToken, setToken, removeAll } from '@/utils/auth'
import { removeFolio } from '@/utils/cookies'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    order: {},
    _folio: null,
    ticket: false,
    prevent: false,
    toHome: false,
    tasks: [],
    statusOrder: {},
    token: getToken(),
    now: new Date(),
    notificationsData: null,
    expDate: null
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ORDER: function(state, order) {
      if (Array.isArray(order.movements) && order.movements.length > 0) {
        order.orderStep = object[order.movements[order.movements.length - 1].status]
      }
      state.order = order
    },
    SET_EXP_DATE: (state, expDate) => {
      state.expDate = expDate
    },
    FOLIO: function(state, folio) {
      state._folio = folio
    },
    PREVENT: function(state, prevent) {
      state.prevent = prevent
    },
    TICKET: function(state, ticket) {
      state.ticket = ticket
    },
    TASKS: function(state, tasks) {
      if (Array.isArray(tasks)) {
        tasks.map(function(task) {
          const isValidStatus = [object.DRIVER_IN_BRANCH, object.BRANCH_DISPATCH, object.BRANCH_IN_PROGRESS, object.BRANCH_IN_PACKAGED, object.BRANCH_SUPPLIED, object.BRANCH_AVAILABLE_VALE].includes(task.orderStep)
          if (isValidStatus) {
            task.status = object.ACCEPTED
          } else if (task.status === object.ORDER_WAITING) {
            task.status = object.SUPPLIED
          }
          return task
        })
      }
      state.tasks = tasks
    },
    SET_PREVIUS: function(state, previus) {
      state.previus = previus
    },
    TO_HOME: function(state, val) {
      state.toHome = val
    },
    STATUS_ORDER: function(state, folio) {
      state.statusOrder[folio] = true
    },
    UPDATE_TIME: (state) => {
      state.now = new Date()
    },
    NOTIFICATIONS_DATA: function(state, notificationsData) {
      state.notificationsData = notificationsData
    },
    CUSTOM_WS: function(state, wsCustom) {
      state.wsCustom = wsCustom
    }
  },
  actions: {
    GetAuthToken({ commit }, data) {
      return new Promise((resolve, reject) => {
        getAuthToken(data.phone, data.countryCode).then(data => {
          removeFolio()
          commit('SET_EXP_DATE', data.expires_in)
          commit('SET_TOKEN', data.access_token)
          setToken(data.access_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetAuthTokenByFolio({ commit }, data) {
      return new Promise((resolve, reject) => {
        getAuthTokenByFolio(data.folio, data.ws).then(data => {
          removeFolio()
          commit('SET_EXP_DATE', data.expires_in)
          commit('SET_TOKEN', data.access_token)
          setToken(data.access_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AuthTokenExpired({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeAll()
        removeFolio()
        resolve()
      })
    },
    start({ commit }) {
      setInterval(() => {
        commit('UPDATE_TIME')
      }, 1000 * 60)
    }
  },
  getters: {
    order: state => state.order,
    folio: state => state._folio,
    ticket: state => state.ticket,
    tasks: state => state.tasks,
    toHome: state => state.toHome,
    prevent: state => state.prevent,
    statusOrder: state => state.statusOrder,
    token: state => state.token,
    now: state => state.now,
    expDate: state => state.expDate,
    notificationsData: state => state.notificationsData,
    wsCustom: state => state.wsCustom
  }
})
